export function getCsrfToken () {
  const metaCsrfToken = document.querySelector('meta[name=csrf-token]')
  if (metaCsrfToken) {
    return metaCsrfToken.getAttribute('content');
  }
}

export function post (url, body) {
  var isFormData = isFormData || false
  return fetch(url, {
    method: 'post',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    body: JSON.stringify(body)
  });
}

export function put (url, body) {
  return fetch(url, {
    method: 'put',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    body: JSON.stringify(body)
  });
}

export function patch(url, body) {
  return fetch(url, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    body: JSON.stringify(body)
  });
}

export function submit(url, formData) {
  return fetch(url, {
    method: 'post',
    credentials: 'include',
    headers:{
      'Accept': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    },
    body: formData
  });
}

export function del (url) {
  return fetch(url, {
    method: 'delete',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': getCsrfToken()
    }
  });
}

export function get (url) {
  return fetch(url, {
    method: 'get',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  });
}
